// extracted by mini-css-extract-plugin
module.exports = {"product":"H_cD","product__image":"H_cF","product__featured":"H_cG","product__prices":"H_cH","product__prices__sale":"H_cJ","product__title":"H_cK","product__title__sale":"H_cL"};